import { render, staticRenderFns } from "./Qualidade.vue?vue&type=template&id=2e6c9e3c"
import script from "./Qualidade.vue?vue&type=script&lang=js"
export * from "./Qualidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports